<template>
    <section class="notice">
        <p>Make your payment directly into our bank account <strong>02-0216-0101134-000</strong>. Please use your <span class="order-text">Order ID</span> as the
            payment reference. Your order won’t be shipped until the funds have cleared in our account. <span class="order-text">Order ID</span> will be
            generated once you complete the purchase.</p>
    </section>
</template>

<script>
    export default {}
</script>

<style lang="scss" scoped>
    .order-text {
        font-weight: bold;
        font-style: italic;
    }
    .notice {
        background: lighten(cornflowerblue, 30%);
        margin: 10px 0;
        padding: 1em;
        color: black;

        h4 {
            font-size: 20px;
            margin-bottom: 5px;
        }

        h5 {
            color: black;
            font-weight: bold;
            margin-top: 5px;
        }
    }
</style>

